<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid fill-height class="indigo lighten-4 mr-1 ml-0">
    <v-layout align-center justify-center :column="windowSize.x < 600">
      <br/>
      <v-flex mr-2 ml-2 xs12 sm8 md4>
        <v-form @submit.prevent="submitForm(form)">
          <v-card class="elevation-12 mx-auto">
            <v-toolbar dark color="primary lighten-1">
              <v-toolbar-title class="font-weight-bold">Set Katalaluan Pencetakan Slip Gaji MDKGU</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="form.ic_number"
                :counter="12"
                label="No. Kad Pengenalan"
                hint="Format: No Kad Pengenalan tanpa '-'"
                persistent-hint
              ></v-text-field>
              <br/>

              <div class="d-flex flex-column">
                <v-btn color="primary" rounded outlined :disabled="currentTime > 0" @click="requestReset(form)">
                    {{ sent ? $t(`resend_verification`, { channel: 'SMS' }) : $t('send_verification', { channel: 'SMS' }) }}
                    <span v-if="currentTime > 0">({{ currentTime }} s)</span>
                  </v-btn>
                <v-text-field
                  v-model="form.verification_code"
                  label="Kod TAC SMS"
                ></v-text-field>
              </div>
              <br/>

              <v-text-field
                v-model="form.password"
                label="Kata Laluan Baru"
                type="password"
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="ma-2 pb-4">
                <v-btn @click.native="$router.go(-1)" color="error lighten-1">
                  Kembali
                </v-btn>
                <v-spacer></v-spacer>
              <v-btn color="primary lighten-1" type="submit">
                Set
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
      <v-card class="ml-4 mr-4 transparent elevation-0">
        <img pa-2 :width="windowSize.x < 600 ? 150 : 250" src="img/undraw_reminder.svg">
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import configuration from '../../configurations'

export default {
  data () {
    return {
      windowSize: {
        x: 0,
        y: 0
      },
      isClosing: false,
      currentTime: 0,
      verify: {
        code: null,
        input: '',
        result: false
      },
      sent: false,
      timer: null,
      form: {
        ic_number: '',
        password: '',
        verification_code: ''
      }
    }
  },
  mounted () {
    this.onResize()
  },
  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    countdown () {
      if (this.currentTime > 0) {
        this.currentTime -= 1
        setTimeout(this.countdown, 1000)
      } else {
        this.currentTime = 0
      }
    },
    async requestReset (form) {
      if (form.ic_number.length !== 12) {
        return this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: 'Isi No Kad Pengenalan dengan betul',
          visible: true
        })
      }
      this.currentTime = 180
      setTimeout(this.countdown, 1)
      this.loading = true
      try {
        const { data } = await axios.post(
          `${configuration.host.EPBT3}/_payroll/requestReset`,
          { ic_number: form.ic_number }
        )
        if (!data || !data.ok) {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'red',
            message: 'Permintaan Gagal, Sila Cuba Sebentar Lagi',
            visible: true
          })
        }
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: 'Internal Server Error',
          visible: true
        })
      } finally {
        this.loading = false
      }
    },
    async submitForm (form) {
      this.loading = true
      try {
        const { statusText } = await axios.post(
          `${configuration.host.EPBT3}/_payroll/resetPassword`,
          {
            ic_number: form.ic_number,
            verification_code: form.verification_code,
            password: form.password
          }
        )
        if (statusText && statusText === 'OK') {
          this.$store.dispatch('snackbar/setSnackBar', {
            color: 'success',
            message: 'Set Katalaluan Baru Berjaya.',
            visible: true
          })
        }
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {
          color: 'red',
          message: 'Internal Server Error',
          visible: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
